import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link, ReferenceOneField, TextField,DateField } from 'react-admin';
import AvatarField from './AvatarField';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
    },
    avatar: {
        marginRight: theme.spacing(1),
    },
}));


const SpentDateField = ({ record, size }) => {
    const classes = useStyles();
    return record ? (
        <div className={classes.root}>
            {(record.spent_at == '--') ? <TextField source="spent_at" label="Spent at" /> : <DateField source="spent_at" showTime label="Spent at" />}
            {/* <Link to={`/users/${record.id}/`} >{record.spent_at}</Link> */}
        </div>
    ) : null;
};

export default SpentDateField;
